type ZoneCreationError = {
  isNameInvalid: boolean;
  hasDuplicateName: boolean;
  hasUnexpectedError: boolean;
  message: string;
};

const zoneCreationError: ZoneCreationError = {
  isNameInvalid: false,
  hasDuplicateName: false,
  hasUnexpectedError: false,
  message: "",
};

export type { ZoneCreationError };

export { zoneCreationError };
